/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function CurrencyKrw(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M240,128H217.88525l21.52686-52.98926a8.00025,8.00025,0,0,0-14.82422-6.02148L200.61523,128H159.38477L135.41211,68.98926a8.00039,8.00039,0,0,0-14.82422,0L96.61523,128H55.38477L31.41211,68.98926a8.00025,8.00025,0,0,0-14.82422,6.02148L38.11475,128H16a8,8,0,0,0,0,16H44.61475l23.97314,59.01074a8.00039,8.00039,0,0,0,14.82422,0L107.38477,144h41.23046l23.97266,59.01074a8.00039,8.00039,0,0,0,14.82422,0L211.38525,144H240a8,8,0,0,0,0-16ZM76,178.74512,61.88477,144H90.11523ZM113.88477,128,128,93.25488,142.11523,128ZM180,178.74512,165.88477,144h28.23046Z" />
    </Svg>
  );
}

export default CurrencyKrw;
